<template>
  <div id="dialog" @click.self="closeDialog">
    <div class="border">
      <!-- <div @click="closeDialog" class="closeImg"></div>
      <span class="message">这是一段信息</span> -->
      <p
        style="
          margin: 20px auto;
          width: 90%;
          font-size: 14px;
          color: grey;
          text-align: left;
        "
      >
        {{ message }}
      </p>
      <el-input
        v-model="inputarea"
        rows="10"
        type="textarea"
        class="textarea"
      ></el-input>
      <br />
      <el-button class="button-search" @click="Upload">Upload</el-button>
    </div>
  </div>
</template>
 
<script>
export default {
  name: "",
  data() {
    return {
      inputarea: "",
    };
  },
  props: {
    message: "",
  },
  methods: {
    change(e) {
      this.$forceUpdate();
    },
    closeDialog() {
      //给父组件传参
      this.$emit("closeDialog", false);
    },
    Upload() {
      this.$emit("closeDialog", false);
      this.$emit("Upload", this.inputarea);
    },
  },
};
</script>
 
<style scoped>
#dialog {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;
  z-index: 100;
}
.border {
  text-align: center;
  background-color: white;
  border-radius: 20px;
  width: 60%;
  height: 60%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.button-search {
  background-color: #e6a23c;
  border: 0px #e6a23c;
  color: #ffff;
  margin-top: 30px;
}
.textarea {
  width: 90%;
}
</style>

<style >
.el-textarea__inner {
  resize: none;
}
</style>


// WEBPACK FOOTER //
// src/components/TaskUpload.vue